import React, { useState, useEffect, useRef } from 'react';
import Select from 'react-select';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import './EmployeeTracking.css';
import jsPDF from "jspdf";
import "jspdf-autotable";
import ExcelJS from 'exceljs';
import { selectStyles } from '../../../assets/Styles/selectStyle';
import { getDistrict, getProject, getStates, fetchMonths, getEmployeeSummaryDrilldownFullDetails } from '../../../services/monthlyAttendanceService';
import { capitalizeFirstLetter } from '../../../utils/validations';
import { getPostedAndRelievedCount, getPostedAndRelievedCountDrilldown, getPostedAndRelievedCountDistDrilldown, getTrackingDetails } from '../../../services/employeePostingService';
import { format } from 'date-fns';
const EmployeeTracking = () => {
    const currentYear = new Date().getFullYear();
    const [state, setState] = useState(3);
    const [district, setDistrict] = useState(null);
    const [date, setDate] = useState('');
    const [stateOptions, setStateOptions] = useState([]);
    const [districtOptions, setDistrictOptions] = useState([]);

    const [attendanceData, setAttendanceData] = useState([]);


    const effectRan = useRef(false);
    const [isFocused, setIsFocused] = useState({
        state: false,
        district: false,

        date: false,

    });
    const [errors, setErrors] = useState({});
    const yearInputRef = useRef(null);


    const isFetchDataEnabled = state && district && date;




    // Fetch states
    useEffect(() => {
        const fetchStates = async () => {
            try {
                const data = await getStates();
                setStateOptions(
                    data.map(item => ({
                        value: item.id,
                        label: capitalizeFirstLetter(item.stateName),
                    }))
                );
            } catch (error) {
                console.error('Error fetching states:', error);
                setErrors(prev => ({ ...prev, general: 'Failed to load states' }));
            }
        };
        if (!effectRan.current) {
            fetchStates();
        }
        return () => {
            effectRan.current = true;
        }
    }, []);






    // Fetch districts when state changes
    useEffect(() => {
        if (state) {
            const fetchDistricts = async () => {
                try {
                    const data = await getDistrict(state);
                    setDistrictOptions(
                        data.map(item => ({
                            value: item.districtId,
                            label: item.districtName,
                        }))
                    );
                } catch (error) {
                    console.error('Error fetching districts:', error);
                    setErrors(prev => ({ ...prev, general: 'Failed to load districts' }));
                }
            };
            // if (!effectRan.current) {
            fetchDistricts();
            // }
            // return () => {
            //     effectRan.current = true;
            // }

        } else {
            setDistrictOptions([]);
            setDistrict(null);
        }
    }, [state]);





    // Clear attendance data and fetch status when any dropdown changes
    useEffect(() => {
        setAttendanceData([]);

    }, [state, district,]); // ✅ Add project to depende

    const handleInputChange = (selectedOption, field) => {
        const value = selectedOption ? selectedOption.value : null;
        switch (field) {
            case 'state':
                setState(value);
                setDistrict(null);


                break;
            case 'district':
                setDistrict(value);
                // setProject(null); // ✅ Clear project when district changes
                break;


            default:
                break;
        }
        setErrors(prev => ({ ...prev, [field]: null }));
    };

    const handleYearChange = (date) => {
        setDate(date);
        setErrors(prev => ({ ...prev, date: null }));
    };

    const validateForm = () => {
        const newErrors = {};
        if (!state) newErrors.state = 'State is required';
        if (!district) newErrors.district = 'District is required';
        if (!date) newErrors.date = 'Year is required';
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };
    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!validateForm()) return;

        try {
            const data = await getTrackingDetails(state, district, date,)

            const employeeData = data || [];

            setAttendanceData(employeeData);

        } catch (error) {
            console.error("Error fetching reportrarel data:", error);
            setErrors((prev) => ({
                ...prev,
                general: "Failed to fetch reportrarel data",
            }));
            alert("Failed to fetch reportrarel data. Please try again.");
        }
    };





    // const currentYear = new Date().getFullYear();
    const minDate = new Date(2000, 0, 1);
    const maxDate = new Date(currentYear, 11, 31);



    return (
        <div className="tracking-reportrarel-container">
            <div className="tracking-reportrarel-box">
                <h2 className="tracking-reportrarel-heading">Employee Tracking</h2>
                {errors.general && <div className="error-message">{errors.general}</div>}
                <form onSubmit={handleSubmit}
                >
                    <div className="tracking-reportrarel-maincontainer">
                        <div className="tracking-reportrarel-container-part">
                            <div className={`tracking-reportrarel-floating-label-container ${isFocused.state || state ? 'float-label' : ''}`}>
                                <Select
                                    name="state"
                                    options={stateOptions}
                                    value={stateOptions.find(opt => opt.value === state) || null}
                                    onChange={option => handleInputChange(option, 'state')}
                                    onFocus={() => setIsFocused(prev => ({ ...prev, state: true }))}
                                    onBlur={() => setIsFocused(prev => ({ ...prev, state: false }))}
                                    placeholder=" "
                                    isClearable
                                    menuPortalTarget={document.body}
                                    styles={selectStyles}

                                />
                                <label><span className="required">*</span>State</label>
                                {errors.state && <div className="error-message">{errors.state}</div>}
                            </div>
                        </div>
                        <div className="tracking-reportrarel-container-part">
                            <div className={`tracking-reportrarel-floating-label-container ${isFocused.district || district ? 'float-label' : ''}`}>
                                <Select
                                    name="district"
                                    options={districtOptions}
                                    value={districtOptions.find(opt => opt.value === district) || null}
                                    onChange={option => handleInputChange(option, 'district')}
                                    onFocus={() => setIsFocused(prev => ({ ...prev, district: true }))}
                                    onBlur={() => setIsFocused(prev => ({ ...prev, district: false }))}
                                    placeholder=" "
                                    isClearable
                                    menuPortalTarget={document.body}
                                    styles={selectStyles}

                                />
                                <label> <span className="required">*</span>District</label>
                                {/* {errors.district && <div className="error-message">{errors.district}</div>} */}
                            </div>
                        </div>
                    </div>

                    <div className="tracking-reportrarel-maincontainer">
                        {/* <div className="tracking-reportrarel-container-part">
                            <div className={`tracking-reportrarel-floating-label-container ${isFocused.designation || designation ? 'float-label' : ''}`}>
                                <Select
                                    name="designation"
                                    options={designationOptions}
                                    value={designationOptions.find(opt => opt.value === designation) || null}
                                    onChange={option => handleInputChange(option, "designation")}
                                    
                                    isClearable
                                    className="w-100"
                                />
                                <label>Designation</label>
                                
                            </div>
                        </div> */}
                        <div className="tracking-reportrarel-container-part">
                            <div className={`tracking-reportrarel-floating-label-container ${isFocused.date || date ? 'float-label' : ''}`}>
                                <DatePicker
                                    selected={date}
                                    onChange={(date) => handleYearChange(date)}
                                    onFocus={() => setIsFocused(prev => ({ ...prev, date: true }))}
                                    onBlur={() => setIsFocused(prev => ({ ...prev, date: false }))}
                                    dateFormat="dd-MM-yyyy"
                                    // showYearPicker
                                    placeholderText=""
                                    className="tracking-reportrarel-date-picker"
                                    minDate={minDate}
                                    maxDate={maxDate}
                                    ref={yearInputRef}

                                    title="Select a date"
                                />
                                <label><span className="required">*</span>Date</label>
                                {errors.date && <div className="error-message">{errors.date}</div>}
                            </div>
                        </div>
                        <div className="tracking-reportrarel-container-part">
                            {/* <div className={`tracking-reportrarel-floating-label-container ${isFocused.month || month ? 'float-label' : ''}`}>
                                <Select
                                    name="month"
                                    options={monthOptions}
                                    value={monthOptions.find(opt => opt.value === month) || null}
                                    onChange={option => handleInputChange(option, 'month')}
                                    onFocus={() => setIsFocused(prev => ({ ...prev, month: true }))}
                                    onBlur={() => setIsFocused(prev => ({ ...prev, month: false }))}
                                    placeholder=" "
                                    isClearable
                                    menuPortalTarget={document.body}
                                    styles={selectStyles}
                                />
                                <label><span className="required">*</span>Month</label>
                                {errors.month && <div className="error-message">{errors.month}</div>}
                            </div> */}
                        </div>

                    </div>

                    {/* <div className="tracking-reportrarel-maincontainer">
                        
                        <div className="tracking-reportrarel-container-part">

                        </div>

                    </div> */}

                    <div className="tracking-reportrarel-btn-div">
                        <button type="submit" className="tracking-reportrarel-btn"
                            disabled={!isFetchDataEnabled}


                        >
                            Generate Report
                        </button>
                    </div>
                </form>
            </div>


            <div className="reportrarel-table-monthlt-att-container">
                <table className="reportrarel-table-monthlt-att">
                    <thead>
                        {/* Row 1: Fixed columns (rowSpan=3) + Deviation spanning all hour cols */}
                        <tr>
                            <th rowSpan="3" className="sticky-col sno-col">S.No</th>
                            <th rowSpan="3" className="sticky-col name-col">Employee Name</th>
                            <th rowSpan="3" className="sticky-col name-col">Designation</th>
                            <th rowSpan="3" className="sticky-col loc-col">Location</th>
                            <th rowSpan="3" className="sticky-col loc-col">Attendance Status</th>
                            <th colSpan="48" className="deviation-header">
                                Deviation From Job Location
                            </th>
                        </tr>

                        {/* Row 2: Hour headers */}
                        <tr>
                            {Array.from({ length: 24 }, (_, i) => (
                                <th key={i + 1} colSpan="2" className="hour-header">
                                    {String(i).padStart(2, '0')}:00 – {String(i + 1).padStart(2, '0')}:00 hr
                                </th>
                            ))}
                        </tr>

                        {/* Row 3: 30-min sub-headers */}
                        <tr>
                            {Array.from({ length: 24 }, (_, i) => (
                                <React.Fragment key={`sub-${i}`}>
                                    <th className="sub-header">00 – 30 min</th>
                                    <th className="sub-header">30 – 60 min</th>
                                </React.Fragment>
                            ))}
                        </tr>
                    </thead>

                    <tbody>
                        {attendanceData.length > 0 ? (
                            attendanceData.map((employee, empIdx) => (
                                <tr key={employee.employeeUniqueId || empIdx} className="clickable-row">
                                    <td className="sticky-col sno-col">{empIdx + 1}</td>
                                    <td className="sticky-col name-col">{employee.employeeName}</td>
                                    <td className="sticky-col name-col">{employee.designation}</td>
                                    <td className="sticky-col loc-col">{employee.locationName}</td>
                                    <td className="sticky-col loc-col">{employee.attendanceStatus}</td>

                                    {employee.timeline?.map((hourBlock) =>
                                        hourBlock.slots?.map((slot) => {
                                            const firstRecord = slot.records?.[0];
                                            const rawValue = firstRecord?.distanceFromPreviousMeters;

                                            return (
                                                <td
                                                    key={slot.timeWindow}
                                                    className={`distance-cell ${rawValue ? "has-distance" : ""}`}
                                                    title={`${slot.timeWindow} | Records: ${slot.records?.length || 0} | Distance: ${rawValue ?? 0}`}
                                                >
                                                 {rawValue !== undefined && rawValue !== null ? `${rawValue} km` : "-"} 
                                                </td>
                                            );
                                        })
                                    )}
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan="54" className="no-data-cell">
                                    No data available. Please generate a report.
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>

        </div>
    );
};

export default EmployeeTracking;